var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { log } from "../../base";
import { v4 as uuidv4 } from "uuid";
const localStorageEnalbed = () => {
    let storage;
    try {
        storage = window["localStorage"];
        const x = "__storage_test__";
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    }
    catch (_) {
        return false;
    }
};
export const getUserUUIDFromStorage = () => {
    if (!localStorageEnalbed())
        return uuidv4();
    try {
        const uuid_version = localStorage.getItem("uuid_version");
        if (uuid_version !== "v1") {
            localStorage.removeItem("user_uuid");
            localStorage.setItem("uuid_version", "v1");
            const user_uuid = uuidv4();
            localStorage.setItem("user_uuid", user_uuid);
            return user_uuid;
        }
        const user_uuid = localStorage.getItem("user_uuid");
        if (!user_uuid) {
            throw new Error("no user_uuid");
        }
        return user_uuid;
    }
    catch (e) {
        const user_uuid = uuidv4();
        localStorage.setItem("user_uuid", user_uuid);
        return user_uuid;
    }
};
export const getSavedToken = (userAddress, issuer) => {
    if (!localStorageEnalbed())
        return null;
    try {
        return JSON.parse(localStorage.getItem(`${userAddress.toLowerCase()}_${issuer}`));
    }
    catch (e) {
        clearToken(userAddress, issuer);
        return null;
    }
};
export const saveToken = (userAddress, issuer, token) => {
    if (!localStorageEnalbed())
        return;
    return localStorage.setItem(`${userAddress.toLowerCase()}_${issuer}`, JSON.stringify(token));
};
export const clearToken = (userAddress, issuer) => {
    if (!localStorageEnalbed())
        return;
    return localStorage.removeItem(`${userAddress.toLowerCase()}_${issuer}`);
};
export const clearTokenByToken = (token) => {
    if (!localStorageEnalbed())
        return;
    // find the token in local storage by value and remove it;
    const l = localStorage.length;
    for (let i = 0; i < l; i++) {
        const key = localStorage.key(i);
        if (!key) {
            continue;
        }
        try {
            const tokenItem = JSON.parse(localStorage.getItem(key));
            if (tokenItem.token === token) {
                localStorage.removeItem(key);
                return;
            }
        }
        catch (e) {
            continue;
        }
    }
};
export const checkIfTokenIsExpired = (token) => {
    try {
        if (!token.exp) {
            return true;
        }
        if (token.exp < Math.floor(Date.now() / 1000)) {
            return true;
        }
        return false;
    }
    catch (e) {
        return true;
    }
};
export const getSignChallenge = (payload, api) => __awaiter(void 0, void 0, void 0, function* () {
    const t = "eip191";
    const header = {
        t,
    };
    const network = "ethereum";
    const data = {
        payload,
        header,
        network,
    };
    try {
        const res = yield api.post(`/api/v1/siww/get`, data);
        if (!res.data.success) {
            throw new Error("Failed to get challenge");
        }
        return res.data.challenge;
    }
    catch (e) {
        throw new Error("Failed to get challenge");
    }
});
export const getCookieSignChallenge = (payload, api) => __awaiter(void 0, void 0, void 0, function* () {
    const t = "eip191";
    const header = {
        t,
    };
    const network = "ethereum";
    const data = {
        payload,
        header,
        network,
    };
    try {
        const res = yield api.post(`/api/v1/cookie/sign-message`, data);
        if (!res.data.success) {
            throw new Error("Failed to get challenge");
        }
        return res.data.challenge;
    }
    catch (e) {
        throw new Error("Failed to get challenge");
    }
});
export const verifySignedChallenge = (signedMessage, challenge, issuer, sessionTime, api) => __awaiter(void 0, void 0, void 0, function* () {
    const t = "eip191";
    const sigData = {
        signature: {
            s: signedMessage,
            t,
        },
        message: challenge,
        issuer,
        audience: window.location.hostname,
        timeout: sessionTime,
    };
    const web3AccessTokenRes = yield api.post(`/api/v1/siww/verify`, sigData, {
        headers: {
            wallet_provider: issuer,
        },
    });
    if (!web3AccessTokenRes.data.success) {
        log.error(`Failed to verifySignedChallenge: ${web3AccessTokenRes.data.error}`);
        throw new Error("Failed to verifySignedChallenge");
    }
    console.log("web3AccessTokenRes: ", web3AccessTokenRes);
    return {
        token: web3AccessTokenRes.data.token,
        exp: web3AccessTokenRes.data.exp,
    };
});
export const verifyCookieSignedChallenge = (signedMessage, challenge, marketing_settings, functional_settings, issuer, signer, domain, api) => __awaiter(void 0, void 0, void 0, function* () {
    const t = "eip191";
    const sigData = {
        signature: {
            s: signedMessage,
            t,
        },
        message: challenge,
        marketing_settings,
        functional_settings,
        issuer,
        signer,
        audience: domain,
    };
    const verifyRespose = yield api.post(`/api/v1/cookie/verify`, sigData, {
        headers: {
            wallet_provider: issuer,
        },
    });
    if (!verifyRespose.data.success) {
        log.error(`Failed to verifyCookieSignedChallenge: ${verifyRespose.data.error}`);
        throw new Error("Failed to verifyCookieSignedChallenge");
    }
    return {
        success: verifyRespose.data.success,
    };
});
export const verifyCookieGuestChallenge = (marketing_settings, functional_settings, domain, api) => __awaiter(void 0, void 0, void 0, function* () {
    const t = "eip191";
    const sigData = {
        type: "guest",
        audience: domain,
        marketing_settings,
        functional_settings,
    };
    const verifyRespose = yield api.post(`/api/v1/cookie/verify`, sigData);
    if (!verifyRespose.data.success) {
        log.error(`Failed to verifyCookieGuestChallenge: ${verifyRespose.data.error}`);
        throw new Error("Failed to verifyCookieGuestChallenge");
    }
    return {
        success: verifyRespose.data.success,
    };
});
//# sourceMappingURL=token.utils.js.map